import gql from 'graphql-tag';

export const CreateUserRecentSearch = gql`
    mutation CreateUserRecentSearch(
        $filterType: UserSearchFilter!
        $filterSlug: String!
    ) {
        createUserRecentSearch(filterType: $filterType, filterSlug: $filterSlug)
    }
`;

export const GetUserRecentSearch = gql`
    query GetUserRecentSearch {
        getUserRecentSearch {
            recentSearch {
                searchFilter
                filterSlug
            }
        }
    }
`;

export const DeleteUserRecentSearch = gql`
    mutation DeleteUserRecentSearch(
        $filterType: UserSearchFilter!
        $filterSlug: String!
    ) {
        deleteUserRecentSearch(filterType: $filterType, filterSlug: $filterSlug)
    }
`;
